import { toastSuccess } from 'modules/common/toast';
import { req } from 'react-reqq-lite';
import * as c from './constants';

export const changePassword = (payload, callback = () => {}) => {
  req.post({
    key: c.CHANGE_PASSWORD,
    url: '/api/change_password',
    payload,
    onSuccess: () => {
      toastSuccess('You have successfully change your password.');
      callback();
    },
  });
};

export const checkToken = (params, callback = () => {}) => {
  req.get({
    key: c.CHECK_TOKEN,
    url: `/api/change_password/check_token`,
    params,
    transform: ({ data }) => ({
      data,
    }),
    onSuccess: () => {
      callback();
    },
  });
};
